var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitizedText)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }